export enum CheckYourEmailText {
	HEADING = 'Check your email',
	DESCRIPTION = "We've sent you an email to verify your signed up email address. Remember to check your spam folder just in case and email team@goodkind.com if you need a hand.",
	FAILED_RECEIVING = "Didnt't receive anything?",
	RESEND = 'Get back to sign up',
}
